export default "__VITE_ASSET__DOKHsDTm__"